


























import { Component, Provide, Watch, Vue } from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import { IDailyPerformanceSummary } from "../../models/interfaces/performance/daily-performance-summary.model.interface";
import PerformanceSummaryTable from "@/components/dashboard/PerformanceSummaryTable.vue";
import DailyPerformanceChart from "@/components/dashboard/DailyPerformanceChart.vue";
import Loader from "@/components/Loader.vue";
import DatePicker from "@/components/DatePicker.vue";

const PropertyOverviewModule = namespace("propertyOverviewModule");
const PublisherModule = namespace("publisherModule");
const UserSelectionModule = namespace("userSelectionModule");

@Component({
  components: {
    PerformanceSummaryTable,
    DailyPerformanceChart,
    Loader,
    DatePicker,
  }
})
export default class PerformanceOverview extends Vue {
  @PropertyOverviewModule.Action public retrievePropertiesDailyPerformance;
  @PropertyOverviewModule.Getter public propertiesDailyPerformance;
  @UserSelectionModule.Getter public selectedDates;

  get getDates() {
    return this.selectedDates;
  }

  public chartData: IDailyPerformanceSummary = {
    keys: [],
    loads: [],
    impressions: [],
    clicks: [],
    keyPresses: []
  };

  private loading: boolean = true;

  @Watch("getDates")
  public onDatesChanged() {
    this.updateData();
  }

  public updateData() {
    this.loading = true;
    if (this.selectedDates) {
      this.retrievePropertiesDailyPerformance().then((result) => {
        this.chartData = this.propertiesDailyPerformance;
        this.loading = false;
      });
    }
  }

  public created() {
    this.updateData();
  }
}
